var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SwapInput',_vm._g(_vm._b({class:{
    searchbar: true,
    'show-icon': _vm.value?.trim() === ''
  },attrs:{"value":_vm.value,"label":_vm.label,"description":_vm.description,"dropdown":_vm.dropdown.length > 0 ? _vm.dropdown : null,"show-green-checkmark":_vm.showGreenCheckmark,"is-loading":_vm.isSearchingLandlord},on:{"dropdownClick":_vm.dropdownClick,"blur":_vm.handleBlur}},'SwapInput',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }